import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-admin';
import { push as reduxPush } from 'react-router-redux';
import ImageEye from '@material-ui/icons/RemoveRedEye';

class ShowButton extends Component {
  handleClick = () => {
    const {
      push,
      basePath,
      record,
      path,
    } = this.props;
    const split = path.split('/');
    const tabNumber = split.length > 3 ? Number.parseInt(split.pop(), 10) : NaN;

    push(`${basePath}/${record.id}/show${!Number.isNaN(tabNumber) ? `/${tabNumber}` : ''}`);
  }

  render() {
    return (
      <Button label="Show" onClick={this.handleClick}>
        <ImageEye />
      </Button>
    );
  }
}

ShowButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object, // eslint-disable-line
};

ShowButton.defaultProps = {
  push: () => {},
  record: {},
};

export default connect(null, {
  push: reduxPush,
})(ShowButton);



// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/ShowButton.js